import React, { SVGProps } from 'react';

const SortDesc: React.FC<SVGProps<SVGSVGElement>> = props => (
    <svg style={{ marginLeft: '5px', width: '15px', height:'15px', opacity:'0.8' }} version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" >
        <g>
            <path d="M26.9,121.3h242.5c14.9,0,26.9-12.1,26.9-26.9c0-14.9-12.1-26.9-26.9-26.9H26.9C12.1,67.4,0,79.4,0,94.3
            C0,109.2,12.1,121.3,26.9,121.3"/>
            <path d="M26.9,282.9h188.6c14.9,0,26.9-12.1,26.9-26.9c0-14.9-12.1-26.9-26.9-26.9H26.9C12.1,229.1,0,241.1,0,256
            C0,270.9,12.1,282.9,26.9,282.9"/>
            <path d="M26.9,444.6h188.6c14.9,0,26.9-12.1,26.9-26.9c0-14.9-12.1-26.9-26.9-26.9H26.9C12.1,390.7,0,402.8,0,417.7
            C0,432.6,12.1,444.6,26.9,444.6"/>
            <path d="M304.3,355.9l80.8,80.8c5,5,12,7.9,19.1,7.9c7.1,0,14-2.9,19.1-7.9l80.8-80.8c10.5-10.5,10.5-27.6,0-38.1
            c-10.5-10.5-27.6-10.5-38.1,0l-61.8,61.8l-61.8-61.8c-10.5-10.5-27.6-10.5-38.1,0C293.8,328.3,293.8,345.4,304.3,355.9L304.3,355.9
            z"/>
            <path d="M377.3,94.3v323.4c0,14.9,12.1,26.9,26.9,26.9c14.9,0,26.9-12.1,26.9-26.9V94.3c0-14.9-12.1-26.9-26.9-26.9
            C389.3,67.4,377.3,79.4,377.3,94.3"/>
        </g>
    </svg>
);

export default SortDesc;
